import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="regulatory_updates" pageTitle="Regulatory Updates" pageDescription="Stay current on regulatory changes affecting pharma, medical devices, and IVD — expert analysis of new guidelines and legislation." />;

export const Route = createFileRoute("/en/regulatory-updates/")({
  head: () => buildRouteHead("/en/regulatory-updates"),
  component: ContentListingRoute,
});

